import { Component, OnInit, HostListener } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Entry } from 'contentful';
import {IAlbum, Lightbox} from "ngx-lightbox";

@Component({
  selector: 'app-category-list',
  templateUrl: './reference-list.component.html',
  styleUrls: ['./reference-list.component.css']
})
export class ReferenceListComponent implements OnInit {
  references: Entry<any>[];
  artifactsForLightBox: IAlbum[];
  columnCount:number = 4;

  constructor(private contentfulService: ContentfulService, private _lightbox: Lightbox) { }
  ngOnInit() {
    if (window && window.innerWidth && window.innerWidth < 700) {
      this.columnCount = 1;
    }

    this.contentfulService.getReferanslar()
      .then(references => {
        this.references = references;
        this.artifactsForLightBox = references.map((artifact) => {
          return {
            src: artifact.fields.logo.fields.file.url,
            caption: artifact.fields.companyName,
            thumb: artifact.fields.logo.fields.file.url
          }
        });
      });
  }

  open(index: number): void {
    this._lightbox.open(this.artifactsForLightBox, index);
  }

  close(): void {
    this._lightbox.close();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window && window.innerWidth && window.innerWidth < 700) {
      this.columnCount = 1;
    } else {
      this.columnCount = 4;
    }
  }
}
